import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import SearchResultsSection from './SearchResultsSection'
import HitContainerHeader from './HitContainerHeader'
import {Hit, DoSearch, GetItemPropsFn, SearchResults, EventHit} from './'
import SearchActionLink from './SearchActionLink'

interface Props {
  allSearchResults: SearchResults,
  inputValue: string,
  hits: Array<EventHit|Hit>,
  doSearch: DoSearch,
  highlightedIndex: number,
  getItemProps: GetItemPropsFn,
  style?: CSSStyleDeclaration,
  setHighlightedIndex: (idx: number | null) => void
}

const HitContainer = ({
  allSearchResults,
  inputValue,
  hits,
  doSearch,
  highlightedIndex,
  getItemProps,
  setHighlightedIndex,
  style
}: Props) =>
  <div key='results' className='algolia-hit-container' style={style}>
    <HitContainerHeader
      inputValue={inputValue}
      hasResults={hits.length > 0}
      doSearch={doSearch}
    />

    <SearchResultsSection
      searchMetadata={allSearchResults}
      hits={hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      previousResultsCount={0}
      type='community'
      viewAllUrl=''
      setHighlightedIndex={setHighlightedIndex}
    />

    <SearchActionLink icon='search' href={`/search?q=${inputValue}`}>
      <Phrase p='live.search.view.all' />
    </SearchActionLink>
    <SearchActionLink icon='edit' href='/topic/new'>
      <Phrase p='live.search.ask.question' />
    </SearchActionLink>
  </div>

export default HitContainer
